import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const articlePreviews = [
  {
    slug: "pandabuy-spreadsheet-guide",
    title: "Complete Pandabuy Spreadsheet Guide",
    desc: "New to pandabuy spreadsheets? This comprehensive guide walks you through everything — from finding the best curated spreadsheets to comparing quality ratings and discovering hidden budget gems.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20editorial%20fashion%20photography%20showing%20soft%20cream%20cashmere%20sweater%20folded%20neatly%20on%20light%20beige%20linen%20fabric%20with%20gentle%20natural%20daylight%20from%20window%20clean%20aesthetic%20modern%20european%20style%20warm%20ambient%20tone%20high%20detail%20soft%20shadows%20professional%20commercial%20photography%20elegant%20simple%20composition%20fresh%20inviting%20mood&width=600&height=400&seq=article-grid-featured-v5&orientation=landscape",
    isFeatured: true,
  },
  ...articles.map((a) => ({
    slug: a.slug,
    title: a.title,
    desc: a.subtitle,
    image: a.headerImage,
    isFeatured: false,
  })),
];

export default function ArticlePreview() {
  const featured = articlePreviews[0];
  const grid = articlePreviews.slice(1);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="mb-10 flex flex-col lg:flex-row lg:items-end justify-between gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              PandabuySpreadsheet Guides
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-md">
              Expert articles to help you master the pandabuy spreadsheet shopping experience.
            </p>
          </div>
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
          >
            View all guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-2/5">
            <Link
              to={`/${featured.slug}`}
              className="group block rounded-3xl overflow-hidden border border-background-200 bg-white hover:border-accent-200 transition-all cursor-pointer h-full"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="p-6">
                <span className="text-xs font-medium text-accent-500 uppercase tracking-wider">Featured Guide</span>
                <h3 className="mt-2 text-xl md:text-2xl font-heading font-bold text-foreground-950 leading-snug group-hover:text-accent-600 transition-colors">
                  {featured.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {featured.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-accent-600 group-hover:gap-2 transition-all">
                  Read Guide
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {grid.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col rounded-2xl overflow-hidden border border-background-200 bg-white hover:border-accent-200 transition-all cursor-pointer"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-accent-600 group-hover:gap-1.5 transition-all">
                    Read more
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}